import { ROLES } from "@/utils/roles";

import { MODULE } from "./customers.actionTypes";

// To be refactor in using customersv2 in the future
export const companySelector = (state) => {
  try {
    const company = state.getIn(["customers", "company"]).toJS();

    return company;
  } catch (_) {
    return null;
  }
};

export const getCurrencySymbol = (state) => companySelector(state)?.currencySymbol ?? "$";

// To be refactor in using customersv2 in the future
export const userSelector = (state) => {
  const user = state.getIn(["customers", "user"]);

  return user ? user.toJS() : null;
};

export const getPlannerSettings = (state, { key }) => {
  // Optional chaining, not a bare read: companySelector returns null before the company loads (and
  // in tests with a bare store), and this selector is now called from the scheduler handlers, which
  // mount before that. Returning null there matches the not-found case callers already handle.
  const selectedSetting = companySelector(state)?.settings?.plannerSettings?.find(
    (p) => p.key === key
  );

  if (selectedSetting) {
    return selectedSetting;
  }

  return null;
};

export const getTimeTrackingSettings = (state, { key }) => {
  const selectedSetting = companySelector(state).settings.timeTrackingSettings.settings.find(
    (p) => p.key === key
  );

  if (selectedSetting) {
    return selectedSetting;
  }

  return null;
};

export const getPdfSettings = (state, { key }) => {
  const selectedSetting = companySelector(state).settings.pdfSettings.find((p) => p.key === key);

  if (selectedSetting) {
    return selectedSetting;
  }

  return null;
};

export const getOrdersSettings = (state, { key }) => {
  const selectedSetting = companySelector(state).settings.ordersSettings.orders.find(
    (p) => p.key === key
  );

  if (selectedSetting) {
    return selectedSetting;
  }

  return null;
};

export const getTimeTrackingWorkDays = (state) => {
  const company = companySelector(state);

  return company?.settings?.timeTrackingSettings?.workDays &&
    Array.isArray(company.settings.timeTrackingSettings.workDays)
    ? company.settings.timeTrackingSettings.workDays
    : [];
};

export const getWeekCommencesOn = (state) => {
  return companySelector(state)?.settings?.timeTrackingSettings?.weekCommencesOn ?? 0;
};

export const getUserRole = (state) => {
  const user = userSelector(state);

  return ROLES[user.role].id;
};

export const getCompanyTaxRate = (state) => {
  const company = companySelector(state);
  return company?.taxRate || 0;
};

const CUSTOMER_DATE_FORMAT_KEY = "CUSTOMER_DATE_FORMAT";
const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";

export const getCustomerDateFormatSetting = (state) => {
  const company = companySelector(state);
  const customerSettings = company?.settings?.customerSettings || [];
  const dateFormatSetting = customerSettings.find(
    (setting) => setting.key === CUSTOMER_DATE_FORMAT_KEY
  );
  return dateFormatSetting?.value || company?.dateFormat || DEFAULT_DATE_FORMAT;
};

// Do not use this function ever again.
export const getMinLengthProducts = (state) => {
  const company = companySelector(state);
  let minLength = 0;

  if (company) {
    const allProductsSettings = company.settings?.productSettings?.allProducts || [];
    if (allProductsSettings) {
      const settingsLength = allProductsSettings.find(
        (setting) => setting.key === "AP_MIN_LENGTH_MM"
      );

      if (settingsLength?.isSelected) {
        minLength = parseInt(settingsLength.value, 10);
      }
    }
  }

  return minLength;
};

export const getMinLengthLinealFeet = (state) => {
  const company = companySelector(state);
  let minLength = 0;

  if (company) {
    const productOptions = company.settings?.ordersSettings?.productOptions || [];

    if (productOptions.length) {
      const settingsLength = productOptions.find((setting) => setting.key === "AP_MIN_LENGTH_FT");

      if (settingsLength?.isSelected) {
        minLength = parseFloat(settingsLength.value);
      }
    }
  }

  return minLength;
};

// CUSTOMER CONTACTS
export const isFetchingCustomerContacts = (state) =>
  state.getIn([MODULE, "isFetchingCustomerContacts"]);
export const isFetchingCustomerAddresses = (state) =>
  state.getIn([MODULE, "isFetchingCustomerAddresses"]);
export const isContactsModalOpen = (state) => state.getIn([MODULE, "isContactsModalOpen"]);
export const contactModalType = (state) => state.getIn([MODULE, "contactModalType"]);
export const editContact = (state) => state.getIn([MODULE, "editContact"]);
export const customerContacts = (state) => state.getIn([MODULE, "contacts"]);
export const selectedContacts = (state) => state.getIn([MODULE, "selectedContacts"]);
export const contactsToEmail = (state) => state.getIn([MODULE, "contactsToEmail"]);
export const getSearch = (state) => state.getIn([MODULE, "search"]);
export const getCustomer = (state) => state.getIn([MODULE, "customer"]);
export const customerAddresses = (state) => state.getIn([MODULE, "addresses"]);
/**
 * @param {object} state redux store state
 * @param {string} params.settingsType primary object key to find settings
 * @param {string} params.subType secondary type to find settings
 * @param {string} params.settingsKey key to find specific record of settings
 * @param {string=} params.specificKey optional key to get the specific details in the record
 * @returns {object | string | boolen | null}
 */
export const getCompanySettings = (
  state,
  { settingsType, subType, settingsKey, specificKey = "" }
) => {
  const settings = companySelector(state)?.settings ?? null;

  if (!settings) {
    return null;
  }

  if (!settings[settingsType] || !settingsKey) {
    return null;
  }

  const { [settingsType]: companySettingsType } = settings;

  if (companySettingsType?.[subType]) {
    const specificSettings = companySettingsType[subType].find(({ key }) => key === settingsKey);

    if (typeof specificSettings === "object" && specificKey in specificSettings) {
      return specificSettings[specificKey];
    }

    return specificSettings || null;
  }

  return null;
};

// Pagination
export const isArchivedCustomerIncluded = (state) =>
  state.getIn([MODULE, "isArchivedCustomerIncluded"]);

export const getSearchCustomer = (state) => state.getIn([MODULE, "searchCustomer"]);

export const getCustomerLists = (state) => state.getIn([MODULE, "customers"]);

export const isFetchingCustomerLists = (state) => state.getIn([MODULE, "isFetchingCustomerLists"]);

export const getPagination = (state) => state.getIn([MODULE, "pagination"]);

export const getSort = (state) => state.getIn([MODULE, "pagination", "sortBy"]);

export const getSortField = (state) => {
  const sort = getSort(state);

  if (sort !== "") {
    return sort.split(":")[0];
  }

  return "";
};

export const getSortDirection = (state) => {
  const sort = getSort(state);

  if (sort !== "") {
    return sort.split(":")[1];
  }

  return "";
};

export const getFeatureFlag = (state, code) => {
  const company = companySelector(state);
  const flags = company?.featureFlags ?? [];
  return flags.find((f) => f.code === code) || null;
};

export const isFeatureFlagEnabledWeb = (state, code) => {
  const flag = getFeatureFlag(state, code);
  return flag?.isEnabledWeb ?? false;
};

export const isSavingCompanyData = (state) => {
  try {
    // Note: The legacy customers module is registered as "customers" in the Redux store,
    // not "customersv2" (which is the newer module)
    return state.getIn(["customers", "isPending"]) || false;
  } catch (_) {
    return false;
  }
};
